import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Story } from "./components/Story";
import { Philosophy } from "./components/Philosophy";
import { MenuSection } from "./components/MenuSection";
import { Gallery } from "./components/Gallery";
import { Spaces } from "./components/Spaces";
import { Reservation } from "./components/Reservation";
import { Location } from "./components/Location";
import { Footer } from "./components/Footer";
import { StickyBar } from "./components/StickyBar";

const Site = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="pb-[57px] md:pb-0" data-testid="sant-irene-site">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Story />
        <Philosophy />
        <MenuSection />
        <Gallery />
        <Spaces />
        <Reservation />
        <Location />
      </main>
      <Footer />
      <StickyBar />
      <Toaster position="bottom-center" toastOptions={{ style: { background: "#2C0F1A", color: "#F5EFE6", border: "1px solid rgba(198,146,85,0.35)" } }} />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <Site />
    </LanguageProvider>
  );
}

export default App;
